module.exports = __webpack_public_path__ + "static/img/5.ae9c7fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/5.png
// module id = sDLr
// module chunks = 0